import { environment } from '../../../environments/environment';

const apiRoute = environment.serverHost + 'api/';

export default apiRoute;
